import axios from "../../utils/axios";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  mailConfigurations: [],
  mailConfiguration: {},
};

const mailConfigurationSlice = createSlice({
  name: "mailConfiguration",
  initialState,
  reducers: {
    setMailConfigurations(state, action) {
      state.mailConfigurations = action.payload;
    },
    setMailConfiguration(state, action) {
      state.mailConfiguration = action.payload;
    },
  },
});

export function getAllMailConfigurations() {
  return async (dispatch) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No token");
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/mail-configuration/all`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      dispatch(
        mailConfigurationSlice.actions.setMailConfigurations(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(mailConfigurationSlice.actions.setMailConfiguration({}));
      return Promise.reject(error.message);
    }
  };
}

export function getMailConfiguration() {
  return async (dispatch) => {
    const impersonationToken = localStorage.getItem("impersonationToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No token");
    try {
      const token = impersonationToken ? impersonationToken : accessToken;
      const response = await axios.get(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/mail-configuration`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(
        mailConfigurationSlice.actions.setMailConfiguration(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(mailConfigurationSlice.actions.setMailConfiguration({}));
      return Promise.reject(error.message);
    }
  };
}

export function createMailConfiguration({ data }) {
  return async (dispatch) => {
    const impersonationToken = localStorage.getItem("impersonationToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No token");
    try {
      const token = impersonationToken ? impersonationToken : accessToken;
      const response = await axios.post(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/mail-configuration`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(
        mailConfigurationSlice.actions.setMailConfiguration(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(mailConfigurationSlice.actions.setMailConfiguration({}));
      return Promise.reject(error.message);
    }
  };
}

export function updateMailConfiguration({ data }) {
  return async (dispatch) => {
    const impersonationToken = localStorage.getItem("impersonationToken");
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) return Promise.reject("No token");
    try {
      const token = impersonationToken ? impersonationToken : accessToken;
      const response = await axios.put(
        `${process.env.REACT_APP_POS2CLOUD_BACKEND_URL}/mail-configuration`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(
        mailConfigurationSlice.actions.setMailConfiguration(response.data.data)
      );
      return Promise.resolve(response.data.message);
    } catch (error) {
      dispatch(mailConfigurationSlice.actions.setMailConfiguration({}));
      return Promise.reject(error.message);
    }
  };
}

export default mailConfigurationSlice.reducer;
